import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import "./OrdersAndRevenueSection.css";
import analyticsService from "../../../services/analyticsService";

const emptyPeriods = {
  today: 0,
  yesterday: 0,
  week: 0,
  month: 0,
  lastMonth: 0,
};

const readPeriods = (src) => ({
  today: src?.today || 0,
  yesterday: src?.yesterday || 0,
  week: src?.week || 0,
  month: src?.month || 0,
  lastMonth: src?.lastMonth || 0,
});

function OrdersAndRevenueSection() {
  const [ordersData, setOrdersData] = useState(emptyPeriods);
  const [revenueData, setRevenueData] = useState(emptyPeriods);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await analyticsService.getRevenueAnalytics();

        if (response.success && response.data) {
          const {
            orders,
            revenue,
            combinedOrders,
            combinedRevenue,
          } = response.data;

          // Prefer combined totals (packages + wallet recharges). Fall back
          // to package-only fields if backend hasn't been updated yet.
          setOrdersData(readPeriods(combinedOrders || orders));
          setRevenueData(readPeriods(combinedRevenue || revenue));
        }
      } catch (error) {
        console.error("Error fetching revenue analytics:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <motion.div
      className="orders-revenue-section"
      initial={{ opacity: 0, x: -20 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
    >
      <div className="section-title">
        <h2>Orders & Revenue</h2>
        <span className="material-symbols-outlined">payments</span>
      </div>

      <div className="orders-revenue-cards">
        <div className="data-card">
          <h3>Orders</h3>
          <p>Today: {ordersData.today}</p>
          <p>Yesterday: {ordersData.yesterday}</p>
          <p>Week: {ordersData.week}</p>
          <p>Month: {ordersData.month}</p>
          <p>Last Month: {ordersData.lastMonth}</p>
        </div>
        <div className="data-card">
          <h3>Revenue</h3>
          <p>Today: ৳{revenueData.today}</p>
          <p>Yesterday: ৳{revenueData.yesterday}</p>
          <p>Week: ৳{revenueData.week}</p>
          <p>Month: ৳{revenueData.month}</p>
          <p>Last Month: ৳{revenueData.lastMonth}</p>
        </div>
      </div>
    </motion.div>
  );
}

export default OrdersAndRevenueSection;
